import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { setItem } from "./localStorageUtils";
export async function getSafeDeviceInfo() {
  let platform = "Unknown Platform";
  let deviceId = "";
  let ip = "";
  try {
    const isElectron =
      typeof window !== "undefined" &&
      window.process &&
      window.process.versions &&
      window.process.versions.electron;

    const isMobileBrowser = /Mobi|Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );
    platform = isElectron
      ? 2 // "electron"
      : isMobileBrowser
      ? 3 // "mobile"
      : 1; // "web"
    try {
      // const res = await fetch("https://api64.ipify.org?format=json");
      // const data = await res.json();
      // ip = data.ip ||  null;
      const res = await fetch("https://api64.ipify.org?format=json");
      if (!res.ok) throw new Error("Network error");

      const data = await res.json();
      ip = data?.ip || null;
    } catch (err) {
      ip = null; // fallback
    }
    if (isElectron) {
      try {
        if (window.electronAPI && window.electronAPI.getDeviceInfo) {
          const electronInfo = window.electronAPI.getDeviceInfo();
          deviceId = electronInfo.deviceId ;
        }
      } catch (err) {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        deviceId = result.visitorId || null;
      }
    } else {
      try {
        const fp = await FingerprintJS.load();
        const result = await fp.get();
        deviceId = result.visitorId || null;
      } catch (err) {
        deviceId = null;
      }
    }
    setItem("deviceType",platform)
    setItem("deviceId",deviceId)
    return {
      platform,
      deviceId: deviceId || null,
      ip: ip || null,
    };
  } catch (err) {
    setItem("deviceType",1)
    return {
      platform: 1, // "web"
    };
  }
}
